const account = {
  path: '/account',
  name: 'accountManagement',
  icon: 'el-icon-s-custom',
  redirect: '/account/sub-account',
  component: () => import('@/pages/layout/appMain'),
  children: [
    {
      icon: 'el-icon-user',
      name: 'subAccount',
      path: '/account/sub-account',
      component: () => import('@/pages/account/subAccount/index')
    },
    {
      icon: 'el-icon-s-check',
      name: 'enterpriseAccount',
      path: '/account/enterprise-account',
      component: () => import('@/pages/usercontrol/userinfo')
    },
    {
      icon: 'el-icon-s-operation',
      name: 'roleManagement',
      path: '/account/role',
      component: () => import('@/pages/usercontrol/userLimits')
    },
    {
      icon: 'el-icon-set-up',
      name: 'scopeManage',
      path: '/account/scope',
      component: () => import('@/pages/account/scope/index')
    },
    {
      icon: 'el-icon-lock',
      name: 'securitySettings',
      path: '/account/security',
      component: () => import('@/pages/account/securitySettings/index')
    },
    {
      icon: 'el-icon-office-building',
      name: 'enterpriseAdmin',
      path: '/account/enterprise-admin',
      component: () => import('@/pages/account/enterpriseAdmin/index')
    }
  ]
}

export default account
